import { gql } from "@apollo/client";

export const LOGIN = gql`
    mutation VisalLogin($input: LoginInput) {
        login(input: $input) {
            access_token
            refresh_token
            expires_in
            token_type
            agent_token
            user {
                user_id
                email
                first_time_signin
                accept_waiver_aggreement
                created_at
                updated_at
                broker_role {
                    broker_role_id
                    position
                    privileges
                }
                employee {
                    employee_id
                    employee_first_name
                    employee_last_name
                    employee_phonenumber
                    employee_email
                    emp_abbrv
                    signature
                    should_sign
                    accept_waiver_aggreement
                    waiver_accepted_at
                    broker_config {
                        broker_configuration_id
                        broker_company_name
                        broker_company_logo
                        broker_color_schema
                        broker_website
                        broker_address {
                            broker_address_id
                            street
                            region
                            country
                        }
                    }
                }
            }
        }
    }
`;

export const CHANGE_PASSWORD = gql`
    mutation ChangePassword($id: ID!, $password: String!) {
        changePasswordByEmployee(employee_id: $id, new_password: $password)
    }
`;
